import React from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const NAV_LINKS = [
  { to: '/', label: 'Globe' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/history', label: 'History' },
  { to: '/alerts', label: 'Alerts' },
  { to: '/settings', label: 'Settings' },
];

const Navbar = () => {
  return (
    <nav className="border-b border-zinc-200 bg-white/80 backdrop-blur-xl sticky top-0 z-50 dark:border-white/[0.06] dark:bg-black/80">
      <div className="mx-auto px-6">
        <div className="flex justify-between h-14">
          <div className="flex items-center">
            <Link
              to="/"
              className="text-sm font-bold uppercase tracking-[0.25em] text-zinc-900 mr-10 dark:text-white"
            >
              Sunshell
            </Link>
            <div className="hidden sm:flex sm:space-x-1">
              {NAV_LINKS.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="px-3 py-1.5 rounded text-xs font-medium uppercase tracking-wider text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100 transition-colors dark:hover:text-white dark:hover:bg-white/[0.04]"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
